export default () => ({
    franelas: []
})